<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <title-text>Settings.</title-text>
      </v-col>
      <v-col cols="12"></v-col>
    </v-row>
  </v-container>
</template>

<script>
import TitleText from "@/components/dashboard/DbTitleText.vue";

export default {
  components: {
    TitleText,
  },
  data() {
    return {};
  },
};
</script>
